import { useCallback } from "react";
import { useAuthQuery } from "./useAuthQuery";

export const useGetInstituteProgress = (queryBody) => {
  const select = useCallback((response) => {
    return response?.data?.data;
  }, []);

  const response = useAuthQuery(
    {
      method: "POST",
      url: "/institute/articles",
      data: queryBody,
    },
    {
      queryKey: ["institute-articles", queryBody],
      select,
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  return response;
};
